// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__3N7uk","appWrapper":"App_appWrapper__11gXZ","title":"App_title__3xt8p","logo":"App_logo__3dxjb","logo--roll":"App_logo--roll__2dzCb"};